import {
    AttributeType,
    CognitoIdentityProviderClient,
    GetUserCommand,
    GetUserCommandInput,
    GetUserCommandOutput,
} from '@aws-sdk/client-cognito-identity-provider'
import getConfig from 'next/config'
import Cookies from 'js-cookie'
import { hasValidAccessToken } from './refresh-token'
import { CognitoErrorTypes } from 'types/cognito'
import { removeCookies } from './logout'

export interface UserModel {
    uuid: string
    email: string
    given_name: string
    family_name: string
    tenant_id: string
    user_type: string
}
type ServiceError = {
    name: CognitoErrorTypes
}

async function getUserByAccessToken() {
    const { COGNITO_REGION: region } =
        getConfig().publicRuntimeConfig
    const input: GetUserCommandInput = {
        AccessToken: Cookies.get('access_token'),
    }
    const command = new GetUserCommand(input)
    const client = new CognitoIdentityProviderClient({
        region,
    })

    const results: GetUserCommandOutput = await client.send(command)
    if (results.Username) {
        const { Username, UserAttributes } = results

        return {
            uuid: Username,
            given_name: UserAttributes?.find(
                (attribute: AttributeType) =>
                    attribute.Name === 'given_name'
            )?.Value as string,
            family_name: UserAttributes?.find(
                (attribute: AttributeType) =>
                    attribute.Name === 'family_name'
            )?.Value as string,
            email: UserAttributes?.find(
                (attribute: AttributeType) => attribute.Name === 'email'
            )?.Value as string,
            tenant_id: UserAttributes?.find(
                (attribute: AttributeType) => attribute.Name === 'custom:tenant_id'
            )?.Value as string,
            user_type: UserAttributes?.find(
                (attribute: AttributeType) => attribute.Name === 'custom:user_type'
            )?.Value as string,
        }
    }
}
async function profile() {

    const has_token = await hasValidAccessToken()
    if (!has_token) return false

    let user: UserModel = false as unknown as UserModel
    try {
        user = (await getUserByAccessToken()) as unknown as UserModel
    } catch (e) {
        const { name } = e as ServiceError
        if (name == CognitoErrorTypes.NotAuthorizedException) {
            removeCookies()
        }
    }
    return user as unknown as UserModel
}

export default profile
